import OneNetworkConfig from '@/onenetwork/core/onenetwork.config'
import PrivateRouter from '@/onenetwork/layouts/PrivateRouter.vue'
import ContractList from '@/modules/contract/views/ContractList.vue'
import ConsultantList from '@/modules/contract/views/ConsultantList.vue'
import CustomerList from '@/modules/contract/views/CustomerList.vue'
import ContractCreatePage from '@/modules/contract/views/ContractCreatePage.vue'
import CommissiontList from '@/modules/contract/views/CommissiontList.vue'
const baseRoute = OneNetworkConfig.baseRoutePath
const contractRouter = [
  {
    path: `${baseRoute}/contracts/list`,
    name: 'contracts-list',
    meta: {
      component: ContractList
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/contracts/create`,
    name: 'contracts-create',
    meta: {
      component: ContractCreatePage
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/consultations/list`,
    name: 'consultations-list',
    meta: {
      component: ConsultantList
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/customers/list`,
    name: 'customers-list',
    meta: {
      component: CustomerList
    },
    component: PrivateRouter,
  },

  {
    path: `${baseRoute}/commission/list`,
    name: 'commission-list',
    meta: {
      component: CommissiontList
    },
    component: PrivateRouter,
  },
]
export default contractRouter
